import { storableError } from '../util/errors';
import { logError } from '../util/log';
import { notifyMailContactEvent } from './mailContact.duck';
import { fetchCurrentUser } from './user.duck';

// ================ Action types ================ //

export const VERIFICATION_REQUEST = 'app/EmailVerification/VERIFICATION_REQUEST';
export const VERIFICATION_SUCCESS = 'app/EmailVerification/VERIFICATION_SUCCESS';
export const VERIFICATION_ERROR = 'app/EmailVerification/VERIFICATION_ERROR';

// ================ Reducer ================ //

const initialState = {
  isVerified: false,

  // verification
  verificationError: null,
  verificationInProgress: false,
};

/**
 *
 * @param state
 * @param action
 */
export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case VERIFICATION_REQUEST:
      return {
        ...state,
        verificationInProgress: true,
        verificationError: null,
      };
    case VERIFICATION_SUCCESS:
      return { ...state, verificationInProgress: false, isVerified: true };
    case VERIFICATION_ERROR:
      return { ...state, verificationInProgress: false, verificationError: payload };
    default:
      return state;
  }
}

// ================ Selectors ================ //

export const verificationInProgress = (state) => {
  return state.emailVerification.verificationInProgress;
};

// ================ Action creators ================ //

export const verificationRequest = () => ({ type: VERIFICATION_REQUEST });
export const verificationSuccess = () => ({ type: VERIFICATION_SUCCESS });
export const verificationError = (error) => ({
  type: VERIFICATION_ERROR,
  payload: error,
  error: true,
});

// ================ Thunks ================ //

export const verify = (verificationToken) => async (dispatch, getState, sdk) => {
  if (verificationInProgress(getState())) {
    return;
  }
  dispatch(verificationRequest());

  // Note that the thunk does not reject when the verification fails, it
  // just dispatches the login error action.

  /** @type {VanSite.CurrentUser} */
  const currentUser = getState().user.currentUser || (await dispatch(fetchCurrentUser()));

  if (!currentUser) {
    dispatch(verificationError(storableError(new Error('Current user missing'))));
    return;
  }

  try {
    await sdk.currentUser.verifyEmail({ verificationToken });

    // Listenpflege macht der Server (contact-event). Der frühere
    // REACT_APP_ENV==='production'-Riegel entfällt: lokal verhindert
    // VANSITE_MAIL_ENABLED=false den Versand - für alle Pfade statt nur hier.
    dispatch(notifyMailContactEvent('email-verified'));

    dispatch(verificationSuccess());
    dispatch(fetchCurrentUser());
  } catch (e) {
    logError(e, 'email-verification-failed');
    dispatch(verificationError(storableError(e)));
  }
};
